import { Directive, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { QuickBetActions } from '../quick-bet-actions';

@Directive({
    standalone: true,
    selector: '[bsNavigateToBetslip]',
    host: {
        '(click)': 'navigateToBetslipCTA()',
    },
})
export class NavigateBetslipDirective {
    private store = inject(Store);

    navigateToBetslipCTA() {
        this.store.dispatch(QuickBetActions.openBetslip());
    }
}
